// extracted by mini-css-extract-plugin
export default {"journalsection":"journal_journalsection__N-Vls","threeblog":"journal_threeblog__WjsJu"};